import getPricingFromField from './getPricingFromField';

const priceSelectionList = (
  fieldNames,
  formFields,
  customPriceCalculators
) => {
  const priceSelections = {};
  fieldNames.forEach(fieldName => {
    if (customPriceCalculators && customPriceCalculators[fieldName]) {
      priceSelections[fieldName] = customPriceCalculators[fieldName](
        fieldName,
        formFields,
        {}
      );
    } else {
      priceSelections[fieldName] = getPricingFromField(formFields[fieldName]);
    }
  });
  return priceSelections;
};

export const priceSelectionListCoupon = (fieldNames, formFields) => {
  const priceSelections = {};
  fieldNames.forEach(fieldName => {
    priceSelections[fieldName] = getPricingFromField(formFields);
  });
  return priceSelections;
};

export default priceSelectionList;
